import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/core/auth/AuthContext';
import { zoneNewService } from '../services/zoneNew.service';

export function useZoneNew() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const userId = profile?.id || '';

  const [projects, setProjects] = useState<any[]>([]);
  const [units, setUnits] = useState<any[]>([]);
  const [parentZones, setParentZones] = useState<any[]>([]);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const [isLoadingUnits, setIsLoadingUnits] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    zone_name: '',
    zone_code: '',
    parent_zone_id: '',
    project_id: '',
    zone_type: 'construction',
    description: '',
    area_m2: '',
    area_unit: '',
    status_code: 'active',
    perimeter_m: '',
    avg_height_m: '',
    color_code: 'bg-emerald-600',
    is_active: true,
    is_sensitive: false,
  });

  const fetchData = useCallback(async () => {
    if (!companyId) return;
    setIsLoadingProjects(true);
    setIsLoadingUnits(true);
    try {
      const [projectsData, unitsData, zonesData] = await Promise.all([
        zoneNewService.getProjects(companyId),
        zoneNewService.getUnits(companyId),
        zoneNewService.getParentZones(companyId)
      ]);
      setProjects(projectsData);
      setUnits(unitsData);
      setParentZones(zonesData);
    } catch (error) {
      console.error('Lỗi lấy dữ liệu khởi tạo:', error);
    } finally {
      setIsLoadingProjects(false);
      setIsLoadingUnits(false);
    }
  }, [companyId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChange = (field: string, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const createZone = async () => {
    if (!companyId || !userId) throw new Error('Unauthenticated');
    setIsSubmitting(true);
    try {
      await zoneNewService.createZone(userId, {
        company_id: companyId,
        project_id: formData.project_id,
        zone_name: formData.zone_name,
        zone_code: formData.zone_code || null,
        parent_zone_id: formData.parent_zone_id || null,
        zone_type: formData.zone_type,
        description: formData.description,
        area_m2: formData.area_m2 ? Number(formData.area_m2) : null,
        area_unit: formData.area_unit || null,
        status_code: formData.status_code,
        perimeter_m: formData.perimeter_m ? Number(formData.perimeter_m) : null,
        avg_height_m: formData.avg_height_m ? Number(formData.avg_height_m) : null,
        color_code: formData.color_code,
        is_active: formData.is_active,
        is_sensitive: formData.is_sensitive,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    projects,
    units,
    parentZones,
    isLoadingProjects,
    isLoadingUnits,
    isSubmitting,
    formData,
    handleChange,
    createZone
  };
}
